import { DateTime } from "luxon";
import { Role } from "../types/shared-module-types";
import { ExternalService } from "../../BillingModule/services/external";

import dayjs, { Dayjs } from "dayjs";
import dayjsBusinessTime from "dayjs-business-time";
import { NOW, getDateFromISOFormat } from "./dateUtils";

dayjs.extend(dayjsBusinessTime);

// Shared
export const SLASH = "—";
export const THE_HUB = "The Hub";
export const TODAY = "Today";
export const THIS_WEEK = "This Week";
export const LAST_WEEK = "Last Week";
export const THIS_MONTH = "This Month";
export const LAST_MONTH = "Last Month";
export const LAST_PAY_PERIOD = "Last pay period";
export const THIS_PAY_PERIOD = "This pay period";
export const YEAR_TO_DATE = "Year to date";
export const LOCKED = "Locked";
export const APPROVED_TEXT = "Approved";
export const PENDING_TEXT = "Pending";
export const EXPORTED_TEXT = "Exported";
export const RESET_TEXT = "Reset";
export const VOID_TEXT = "Void";
export const CLOSED_TEXT = "Closed";
export const COMPLETE_TEXT = "Complete";
export const RESOLVED_TEXT = "Resolved";
export const ACTIVE_TEXT = "Active";
export const INACTIVE_TEXT = "Inactive";
export const CANCELED_TEXT = "Canceled";
export const ORDINARY = "Ordinary";
export const BILLABLE = "Billable";
export const INTERNAL_PROJECT = "ITX Investment: Internal Project";
export const UNPAID_TIME_OFF = "Unpaid Time Off";
export const BENEFITS = "Benefits";
export const UNPAID = "Unpaid";
export const INVOICE_OWNERS_LABEL = "Invoice Owners";
export const ALL_PROJECTS_AND_WORK_ORDERS = "All Projects and Work Orders";
export const ALL_COST_CENTERS = "All Cost Centers";
export const ALL_PROJ_WO = "All Projects, All Work Orders";
export const ALL_WO_PROJ = "All Work Orders, All Projects";
export const ALL_CYCLES = "All Cycles";
export const ALL_CLIENTS = "All Clients";
export const ALL_STATUSES = "All Statuses";
export const ALL_OWNERS = "All Owners";
export const ALL_DEPARTMENTS = "All Departments";
export const ALL_USERS = "All Users";
export const NONE = "None";
export const HOLIDAY = "Holiday";
export const BAMBOO_HR = "BambooHR";
export const CHANGE_GEAR = "ChangeGear";
export const CLOUDFARE_ERROR_MESSAGE =
  "There is inappropriate text in the description of a time entry and it has not been recorded";
export const CLOUDFARE_ERROR =
  "This website is using a security service to protect itself from online attacks. The action you just performed triggered the security solution. There are several actions that could trigger this block including submitting a certain word or phrase, a SQL command or malformed data.";
export const CLIENT_PRICE_SCHEDULED_ERROR =
  "Account Price Level not found for Client";
// ASUITE11-4363: shown when an existing time-off entry (Paid/Unpaid Time Off)
// cannot be resolved in the viewer's own project list because time-off projects
// are excluded from self-view by design (not because the project is inactive).
export const TIME_OFF_SELF_VIEW_MESSAGE =
  "Paid and Unpaid Time Off entries are managed through BambooHR or by a Super Admin. " +
  "To change or remove this entry, please contact your administrator.";
export const STATUS_NOT_STARTED = "NOT STARTED";
export const STATUS_TERMINATED = "TERMINATED";
export const HUBSPOT = "HubSpot";

// shared constant number
export const PROJ_PAID_TIME_OFF_ID = 233;
export const PROJ_UNPAID_TIME_OFF_ID = 405;
export const PROJ_NURSING_MOTHER_ID = 31557;
export const PROJ_MEAL_BREAK_ID = 24056;
export const TASKTYPE_MEAL_BREAK_ID = 30;
export const TASKTYPE_NURSING_MOTHER_ID = 31;
export const TASKTYPE_PAID_TIME_OFF = 32;
export const TASKTYPE_HOLIDAY_ID = 33;
export const TASKTYPE_UNPAID_TIME_OFF_ID = 42;

export const STATUS_ERROR_FORBIDDEN = 403;
export const STATUS_SUCCESS = 200;

export const RECURRING_BILLING_GROUP_ID = 3;

// closed project, task, work orders
export const closed_status = [
  CLOSED_TEXT,
  COMPLETE_TEXT,
  RESOLVED_TEXT,
  INACTIVE_TEXT,
  CANCELED_TEXT,
];

export const meal_break_status = [
  "US Employee - Full Time - Hourly",
  "US Employee - Part Time - Hourly",
  "US Intern",
];

// billable and non billable ids for 'timeEntryTypeId'
export const billableIds = ["1", "3"];
export const nonBillableIds = ["2", "4", "5"];

// Asuite access
export const TIMESHEETS_ADMIN_BASIC_ACCESS = "Timesheets_Admin";
export const APROVED_ALL_BASIC_ACCESS = "Timesheets_ApproveAll_L1";
export const TIMESHEETS_BASIC_ACCESS = "Timesheets_BasicAccess";
export const REPORTS_BASIC_ACCESS = "Timesheets_Reports";
export const SUPER_ADMIN_BASIC_ACCESS = "SuperAdmin_BasicAccess";

// Enviroments
export const DEVELOPMENT = "development";
export const RELEASE = "preprod";
export const PRODUCTION = "production";

// Modules
export const NO_MODULE = "no-module";
export const BILLING_MODULE = "billing";
export const PRODUCTS_MODULE = "products";
export const ADMIN_MODULE = "admin";
export const TIMES_MODULE = "timesheets";
export const USERS_MODULE = "users";
export const CLIENTS_MODULE = "clients";
export const ASSETS_MODULE = "assets";

// Shared Routes
export const ROUTE_HOME = "/";
export const ROUTE_THEHUB_ADMIN = "/admin";
export const ROUTE_NOT_FOUND_PAGE = "/404-page-not-found";
export const ROUTE_FORBIDDEN_PAGE = "/forbidden-page";
export const ROUTE_LOG_OUT = "/log-out";
export const ROUTE_SAMPLE_REPORT = "/sample-report";
export const ROUTE_ACCESS_CONTROL_REPORT_BY_USER =
  "/access-control-report-by-user";
export const ROUTE_ACCESS_CONTROL_REPORT_BY_JIRA_PROJECT =
  "/access-control-report-by-jira-project";
export const ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT =
  "/access-control-report-by-gitlab-project";

// Billing Routes
export const ROUTE_INVOICES_LIST = "/billing";
export const ROUTE_INVOICES_DETAIL = "/billing/invoices/:id";
export const ROUTE_INVOICES_SEARCH = "/billing/search";
export const ROUTE_INVOICES_FILTERS = "/billing/filters";
export const ROUTE_RECURRING_QUERY = "/billing/recurring";
export const ROUTE_PROFFESSIONAL_SERVICES_QUERY =
  "/billing/professional-services";
export const ROUTE_BILLABLE_ITEMS_RESULTS = "/billing/results";

// Products Routes
export const ROUTE_PRODUCTS_LIST = "/products";
export const ROUTE_DELETE_PRODUCT_PAGE = "/product-not-found";
export const ROUTE_PRODUCT_SPOTLIGHT_SUMMARY_REPORT =
  "/products/reports/spotlightSummaryReport";
export const ROUTE_PRODUCT_SPOTLIGHT = "/products/:productId/spotlight";
export const ROUTE_PRODUCT_SPOTLIGHT_HISTORY =
  "/products/:productId/spotlightHistory";
export const ROUTE_PRODUCT_SUCCESSCRITERIA =
  "/products/:productId/successCriteria";

// Times Routes
export const ROUTE_TIMESHEETS = "/time";
export const ROUTE_TIMESHEETS_REPORTS = "/time/reports";
export const ROUTE_QUERY_TIMESHEETS = "/time/query";
export const ROUTE_QUERY_RESULTS_TIMESHEETS = "/time/query/results";
export const ROUTE_APPROVE_TIME_TIMESHEETS = "/time/approve-time";
export const ROUTE_APPROVE_TIME_TIMESHEETS_BY_USER =
  "/time/approve-time/by-user";
export const ROUTE_BAMBOO_TIME_OFF_REPORT = "/time/reports/bambooTimeOffReport";
export const ROUTE_CHANGE_TO_HOLIDAYS_REPORT =
  "/time/reports/changeToHolidaysReport";
export const ROUTE_TIME_CONFIRMATION_REPORT =
  "/time/reports/TimeConfirmationReport";
export const ROUTE_TIME_CONFIRMATION_RESULTS =
  "/time/reports/TimeConfirmationReport/results";
export const ROUTE_WHO_IS_OUT_REPORT = "/time/reports/WhoIsOutReport";
export const ROUTE_MEAL_BREAK_REPORT = "/time/reports/MealBreakReport";

// Users Routes
export const ROUTE_USERS = "/users";
export const ROUTE_USERS_BAMBOO_PROFILE = "/users/bamboo-profile";
export const ROUTE_USERS_PROFILE = "/users/:userId/profile";
export const ROUTE_USERS_ROLES = "/users/:userId/roles";

// Clients Routes
export const ROUTE_CLIENTS = "/clients";
export const ROUTE_CLIENTS_REPORTS = "/clients/reports";
export const ROUTE_CLIENTS_RELATIONSHIP_REVIEW = "/clients/relationshipReviews";
export const ROUTE_CLIENTS_EDIT = "/clients/:id/edit";
export const ROUTE_CLIENTS_DETAILS = "/clients/:id/details";
export const ROUTE_CLIENTS_BILLING_INFO = "/clients/:id/billingInfo";
export const ROUTE_CLIENTS_CONTACTS = "/clients/:id/contacts";
export const ROUTE_CLIENTS_CONTACTS_PROFILE =
  "/clients/:id/contacts/:contactId/contactProfile";
export const ROUTE_CLIENTS_NEW_CONTACTS = "/clients/:id/newContact";
export const ROUTE_CLIENTS_PRICE_EXCEPTIONS = "/clients/:id/priceExceptions";
export const ROUTE_CLIENTS_INVOICES = "/clients/:id/invoices";
export const ROUTE_CLIENTS_NEW_CLIENT = "/clients/newClient";
export const ROUTE_CLIENTS_WORK = "/clients/:id/work";
export const ROUTE_CLIENTS_RELATIONSHIP_REVIEW_TAB =
  "/clients/:id/relationshipReviews";
export const ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS =
  "/clients/:id/relationshipReviews/:relationshipReviewId/keyContacts";
export const ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS =
  "/clients/:id/relationshipReviews/:relationshipReviewId/keyContacts/:keyContactId";
export const ROUTE_CLIENTS_RELATIONSHIP_NEW_KEY_CONTACT_DETAILS =
  "/clients/:id/relationshipReviews/:relationshipReviewId/keyContacts/newKeyContact";
export const ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACTS_CONFIDENCE_HISTORY =
  "/clients/:id/relationshipReviews/:relationshipReviewId/keyContacts/:keyContactId/confidenceHistory";
export const ROUTE_CLIENTS_ADVOCACY_SUMMARY_REPORT =
  "/clients/reports/advocacySummaryReport";
export const ROUTE_CLIENTS_ADVOCACY_DETAIL_REPORT =
  "/clients/reports/advocacyDetailReport";
export const ROUTE_CLIENTS_RELATIONSHIP_UPDATES_REPORT =
  "/clients/reports/relationshipUpdatesReport";
export const ROUTE_CLIENTS_RELATIONSHIP_REVIEW_REPORT =
  "/clients/reports/relationshipReviewReport";
export const ROUTE_CLIENTS_HUBSPOT_INTEGRATION_LOG_REPORT =
  "/clients/reports/hubspotIntegrationLogReport";
export const ROUTE_CLIENTS_CHANGEGEAR_INTEGRATION_LOG_REPORT =
  "/clients/reports/changegearIntegrationLogReport";

// Assets Routes
export const ROUTE_ASSETS = "/assets";
export const ROUTE_ASSETS_MONTHLY_CHARGES_REPORT =
  "/assets/monthly-charges-report";
export const ROUTE_ASSETS_CHANGES_LOG_REPORT = "/assets/change-log-report";

// other routes
export const ROUTE_PROJECTS = "/projects";
export const ROUTE_WORK_ORDERS = "/work-orders";
export const ROUTE_BUS_DEV = "/bus-dev";

export const PENDING = 1;
export const APPROVED = 2;
export const EXPORTED = 3;
export const RESET = 4;
export const VOID = 5;

// IMPORTANT: ROLES SHOULD NOT HAVE SAME NAME IN DIFFERENT MODULES
// Roles - All modules
export const ROLE_SUPER_ADMIN = "Super Admin";
export const ROLE_PRICE_MANAGER = "Price Manager";
// Automatics
export const ROLE_TEAM_MEMBER = "Team Member";
export const ROLE_SUPERVISOR = "Supervisor";
export const ROLE_PROJECT_OWNER = "Project Owner";
export const ROLE_RELATIONSHIP_STEWARD = "Relationship Steward";
export const ROLE_BUSINESS_DEVELOPMENT_LEAD = "Business Development Lead";

// Roles - Billing Module
export const ROLE_ACCOUNTING_ADMINISTRATOR = "Accounting Administrator";
export const ROLE_ACCOUNTING_COORDINATOR = "Accounting Coordinator";
export const ROLE_INVOICE_APPROVER_OWNER = "Invoice Approver - Owner";
export const ROLE_RECURRING_BILLING_OWNER = "Recurring Billing Owner";
export const ROLE_INVOICE_VIEWER = "Invoice Viewer";
export const ROLE_RECURRING_BILLING_ADMIN = "Recurring Billing Admin";

// Roles - Products module
export const ROLE_ALL_PRODUCTS_VIEWER = "All Products Viewer";
export const ROLE_ALL_PRODUCTS_ADMIN = "All Products Admin";
// Automatics
export const ROLE_PRODUCT_VIEWER = "Product Viewer";
export const ROLE_PRODUCT_EDITOR = "Product Editor";
export const ROLE_PRODUCT_ADMIN = "Product Admin";

// Roles - Times Module
export const ROLE_TIMESHEETS_ADMIN = "Time Admin";
export const ROLE_TIMESHEETS_VIEWER = "Time Viewer";
export const ROLE_DELIVERY_TIME_ADMIN = "Delivery Time Admin";

// Roles - Users Module
export const ROLE_USERS_ADMIN = "User Admin";
export const ROLE_USERS_VIEWER = "User Viewer";

// Roles - Clients Module
export const ROLE_CLIENT_ADMIN = "Client Admin";
export const ROLE_CONTACT_ADMIN = "Contact Admin";
export const ROLE_CLIENT_VIEWER = "Client Viewer";

// Roles - Assets Module
export const ROLE_ASSETS_ADMIN = "Assets Admin";
export const ROLE_ASSETS_VIEWER = "Assets Viewer";

// Assets policies
export const ASSETS_ALL_ROLES: Role["name"][] = [
  ROLE_ASSETS_ADMIN,
  ROLE_ASSETS_VIEWER,
  ROLE_SUPERVISOR,
  ROLE_SUPER_ADMIN,
];

export const ASSETS_ADMIN_ROLES: Role["name"][] = [
  ROLE_ASSETS_ADMIN,
  ROLE_SUPER_ADMIN,
];

// Clients policies
export const CLIENTS_ALL_ROLES: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_CONTACT_ADMIN,
  ROLE_CLIENT_VIEWER,
  ROLE_SUPERVISOR,
  ROLE_PROJECT_OWNER,
  ROLE_RELATIONSHIP_STEWARD,
  ROLE_BUSINESS_DEVELOPMENT_LEAD,
];

export const CLIENTS_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
];

export const CLIENTS_RELATIONSHIP_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_SUPERVISOR,
];

export const CLIENTS_CONTACTS_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_CONTACT_ADMIN,
];

export const CLIENTS_ACTIVATE_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_CONTACT_ADMIN,
  ROLE_BUSINESS_DEVELOPMENT_LEAD,
];

export const CLIENTS_CONTACTS_REPORTS_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_CONTACT_ADMIN,
  ROLE_CLIENT_VIEWER,
];

export const CLIENTS_VIEWER_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_CLIENT_ADMIN,
  ROLE_CLIENT_VIEWER,
];

// Users policies
export const USERS_ACCESS: Role["name"][] = [
  ROLE_USERS_ADMIN,
  ROLE_SUPER_ADMIN,
  ROLE_SUPERVISOR,
];

export const USERS_ALL_ROLES: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_USERS_ADMIN,
  ROLE_USERS_VIEWER,
  ROLE_SUPERVISOR,
];

export const USERS_ADMIN_ACCESS: Role["name"][] = [
  ROLE_USERS_ADMIN,
  ROLE_SUPER_ADMIN,
];

// Billing policies
export const ROLE_NOT_OWNERS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ACCOUNTING_ADMINISTRATOR,
  ROLE_ACCOUNTING_COORDINATOR,
  ROLE_SUPERVISOR,
];

export const ROLE_BILLING_MODULE_PERFORM_ACTION: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ACCOUNTING_ADMINISTRATOR,
  ROLE_ACCOUNTING_COORDINATOR,
  ROLE_INVOICE_APPROVER_OWNER,
  ROLE_RECURRING_BILLING_OWNER,
  ROLE_SUPERVISOR,
];

export const ROLE_BILLING_OWNERS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ACCOUNTING_ADMINISTRATOR,
  ROLE_ACCOUNTING_COORDINATOR,
];

export const ROLE_BILLING_MODULE_PERFORM_SEARCH: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ACCOUNTING_ADMINISTRATOR,
  ROLE_ACCOUNTING_COORDINATOR,
  ROLE_SUPERVISOR,
  ROLE_INVOICE_VIEWER,
];

export const ROLE_BILLING_MODULE: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ACCOUNTING_ADMINISTRATOR,
  ROLE_ACCOUNTING_COORDINATOR,
  ROLE_INVOICE_APPROVER_OWNER,
  ROLE_RECURRING_BILLING_OWNER,
  ROLE_SUPERVISOR,
  ROLE_INVOICE_VIEWER,
];

export const ROLE_BILLING_MODULE_EXPORT_INVOICES: Role["name"][] = [
  ROLE_INVOICE_VIEWER,
];

// Products policies
export const PRODUCTS_CREATOR: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ALL_PRODUCTS_ADMIN,
];

export const PRODUCTS_DELETE: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ALL_PRODUCTS_ADMIN,
];

export const PRODUCTS_REPORTS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ALL_PRODUCTS_VIEWER,
  ROLE_ALL_PRODUCTS_ADMIN,
  ROLE_BUSINESS_DEVELOPMENT_LEAD,
  ROLE_PRODUCT_EDITOR,
  ROLE_PRODUCT_ADMIN,
  ROLE_RELATIONSHIP_STEWARD,
];

export const PRODUCTS_ACCESS_CONTROL_REPORTS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_ALL_PRODUCTS_VIEWER,
  ROLE_ALL_PRODUCTS_ADMIN,
  ROLE_BUSINESS_DEVELOPMENT_LEAD,
  ROLE_PRODUCT_EDITOR,
  ROLE_PRODUCT_ADMIN,
];

// Admin access
export const ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_PRICE_MANAGER,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_USERS_ADMIN,
];

// Admin access
export const PRICE_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_PRICE_MANAGER,
];

export const PRICE_TIME_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_PRICE_MANAGER,
  ROLE_TIMESHEETS_ADMIN,
];

// Time admin access
export const TIME_SUPER_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPER_ADMIN,
  ROLE_TIMESHEETS_ADMIN,
];

// Time basic access
export const TIME_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPERVISOR,
  ROLE_PROJECT_OWNER,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_SUPER_ADMIN,
];

// Time basic access
export const TIME_APPROVAL_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPERVISOR,
  ROLE_PROJECT_OWNER,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_SUPER_ADMIN,
  ROLE_DELIVERY_TIME_ADMIN,
];

// Time basic access
export const TIME_VIEWER_AND_ADMIN_ACCESS: Role["name"][] = [
  ROLE_SUPERVISOR,
  ROLE_PROJECT_OWNER,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_SUPER_ADMIN,
  ROLE_TIMESHEETS_VIEWER,
  ROLE_DELIVERY_TIME_ADMIN,
];

// Time basic access
export const TIME_BASIC_ACCESS: Role["name"][] = [
  ROLE_TEAM_MEMBER,
  ROLE_SUPERVISOR,
  ROLE_PROJECT_OWNER,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_SUPER_ADMIN,
  ROLE_DELIVERY_TIME_ADMIN,
];

export const HOLIDAYS_ACCESS: Role["name"][] = [
  ROLE_SUPERVISOR,
  ROLE_TIMESHEETS_ADMIN,
  ROLE_SUPER_ADMIN,
];

// Business days
const holidays: string[] = [];
let holidaysPromise: Promise<void> | null = null;
// Fetches US holidays and computes THIS_MONTHS_BILLING. Only needed by the
// "Mid Month" filter on the Invoices query screen, so callers should invoke
// this lazily from that screen instead of relying on this module's import.
export const loadHolidays = (): Promise<void> => {
  if (!holidaysPromise) {
    holidaysPromise = ExternalService.getYearHolidays("US", NOW.year)
      .then((data) => {
        data.forEach((element) =>
          holidays.push(getDateFromISOFormat(element.date))
        );
        // Add holidays to dayjs
        dayjs.setHolidays(holidays);
        let day: Dayjs = dayjs(NOW.startOf("month").toISODate());
        // Should be the first workable day
        while (!day.isBusinessDay() || day.isHoliday()) {
          day = day.addBusinessDays(1);
        }
        const nextBillingDate: Dayjs = day.addBusinessDays(12);
        THIS_MONTHS_BILLING = DateTime.fromJSDate(nextBillingDate.toDate());
      })
      .catch((err) => {
        // Allow a later retry instead of caching a permanent failure.
        holidaysPromise = null;
        throw err;
      });
  }
  return holidaysPromise;
};
export let THIS_MONTHS_BILLING: DateTime;
